module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "bk-title"
  }, [_vm._v("The Wrong Box")]), _vm._v(" "), _c('p', {
    staticClass: "authorname"
  }, [_vm._v("Robert Louis Stevenson and Lloyd Osbourne")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('span', [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "logo1",
      "src": "Book1/image/fig_logo.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "publisher1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "http://MYSTERIOUSPRESS.COM",
      "target": "_blank"
    }
  }, [_vm._v("MYSTERIOUSPRESS.COM")])])]), _vm._v(" "), _c('p', {
    staticClass: "publisher1"
  }, [_c('span', [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "logo",
      "src": "Book1/image/logo.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc67416","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/Untitled-1.vue
// module id = 78
// module chunks = 0